import ScalarCardSection_vue_vue_type_script_setup_true_lang_default from "./ScalarCardSection.vue.script.js";
//#region src/components/ScalarCard/ScalarCardSection.vue
var ScalarCardSection_default = ScalarCardSection_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarCardSection_default as default };

//# sourceMappingURL=ScalarCardSection.vue.js.map